module.exports = __webpack_public_path__ + "static/media/comment.e07443e3.svg";